import { render, staticRenderFns } from "./KYC.vue?vue&type=template&id=ede9f33a&scoped=true"
import script from "./KYC.vue?vue&type=script&lang=js"
export * from "./KYC.vue?vue&type=script&lang=js"
import style0 from "./KYC.vue?vue&type=style&index=0&id=ede9f33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede9f33a",
  null
  
)

export default component.exports